import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getUsers = async (dataOrigen, refrescar, api, token, body, config) => {
  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.users.length <= 0) {
    const response = await axios(configws)
    data = { users: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.users.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(user => {
      return (
        (
          user.user_id.toLowerCase().includes(queryLowered) ||
          (user.first_name  ? user.first_name.toLowerCase().includes(queryLowered) : false) ||
          (user.last_name   ? user.last_name.toLowerCase().includes(queryLowered) : false) ||
          (user.phone1      ? user.phone1.toLowerCase().includes(queryLowered) : false) ||
          (user.phone2      ? user.phone2.toLowerCase().includes(queryLowered) : false)
        )
        && user.active === 1
      )
  })
  return [
    200,
    {
      allData: data.users,
      total: filteredData.length,
      users: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of users
// ------------------------------------------------
let dataUsers = { users: []}

mock.onGet('/apps/access').reply(async config => {
  const user = getUserData()

  if (config.reset) {
    dataUsers = { users: []}
  }

  const body = {
    office: (config.office === -1 ? user.usercoc.office_id : config.office_id)
  }

  const result = await getUsers(dataUsers, 1, GetApiCOC('getUsers'), user.token, body, config)

  dataUsers = { users: result[1].allData }

  return result
})
